module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer000"
    }
  }, [_c('p', {
    staticClass: "Blurb"
  }, [_vm._v("Anna McVeigh was born and raised in Aotearoa, also known as New Zealand. Having previously worked as a language teacher and tour guide, Anna fell in love with language and aspects of cultural identity. On her explorations throughout Aotearoa, she was inspired by the natural beauty of the country and with Te ao Māori (the Māori world). Over time, Anna has developed a deep interest in Māori history and culture and in particular the proverbs, myths and legends that speak to the heart of human nature and connection. Anna now works from her home as a narrative and somatic therapist, a writer and a musician. She is learning te reo Māori (the Māori language) with her son, Felix Tāne, who is of Māori and European descent.")]), _vm._v(" "), _c('p', {
    staticClass: "Acknowledgements---Bio ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("This book was written with her son in mind and because Anna’s true passion lies in personal development and fostering connection. She believes that nurturing peace, presence and joy, along with deep and intimate connections with ourselves, others and the world around us is what makes life beautiful and meaningful. Anna adores working with children and adults, helping them feel more grounded in who they are, where they come from and where they are going.")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer002"
    }
  }, [_c('p', {
    staticClass: "Graphics"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/9781398485372_txt3.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer003"
    }
  }, [_c('p', {
    staticClass: "Headings"
  }, [_vm._v("Copyright © Anna McVeigh 2024")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-2"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Illustrated by Tukara Matthews")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal-CR ParaOverride-3"
  }, [_vm._v("The right of Anna McVeigh and Tukara Matthews to be identified as author and illustrator of this work has been asserted by them in accordance with sections 77 and 78 of the Copyright, Designs and Patents Act 1988.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal-CR ParaOverride-3"
  }, [_vm._v("All rights reserved. No part of this publication may be reproduced, stored in a retrieval system, or transmitted in any form or by any means, electronic, mechanical, photocopying, recording, or otherwise, without the prior permission of the publishers.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal-CR ParaOverride-3"
  }, [_vm._v("Any person who commits any unauthorised act in relation to this publication may be liable to criminal prosecution and civil claims for damages.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal-CR ParaOverride-3"
  }, [_vm._v("A CIP catalogue record for this title is available from the British Library.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal-CR"
  }, [_vm._v("ISBN  9781398485372 (Paperback)")]), _vm._v(" "), _c('p', {
    staticClass: "Normal-CR ParaOverride-3"
  }, [_vm._v("ISBN  9781398485389 (ePub e-book)")]), _vm._v(" "), _c('p', {
    staticClass: "Normal-CR ParaOverride-3"
  }, [_vm._v("www.austinmacauley.com")]), _vm._v(" "), _c('p', {
    staticClass: "Normal-CR"
  }, [_vm._v("First Published 2024")]), _vm._v(" "), _c('p', {
    staticClass: "Normal-CR"
  }, [_vm._v("Austin Macauley Publishers Ltd"), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("®")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal-CR"
  }, [_vm._v("1 Canada Square")]), _vm._v(" "), _c('p', {
    staticClass: "Normal-CR"
  }, [_vm._v("Canary Wharf")]), _vm._v(" "), _c('p', {
    staticClass: "Normal-CR"
  }, [_vm._v("London")]), _vm._v(" "), _c('p', {
    staticClass: "Normal-CR"
  }, [_vm._v("E14 5AA")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer004"
    }
  }, [_c('p', {
    staticClass: "Dedi ParaOverride-3"
  }, [_vm._v("Darling Felix Tāne,")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-4"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("I dedicate this book to you with much love and appreciation. You are my greatest teacher and the main inspiration for this story. May you feel loved and protected and increasingly more grounded in who you are.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-4"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Aroha nui,")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-5"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Mum")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer005"
    }
  }, [_c('p', {
    staticClass: "Author-Heading ParaOverride-6"
  }, [_vm._v("From the Author")]), _vm._v(" "), _c('p', {
    staticClass: "Acknowledgements---Bio ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("The beginning of ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("A Boy Named Tāne")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v(" mentions the Māori myth of Tāne Mahuta, God of the forest, and how he created the space and light for life to flourish by separating his mother (earth) and his father (sky). The enormous kauri tree in the north of Aotearoa was named after Tāne Mahuta. My hope is that this will inspire people to look more closely at this myth and have conversations with their children about its significance.")])]), _vm._v(" "), _c('p', {
    staticClass: "Acknowledgements---Bio ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("As the story continues, I reflect on themes of parenting and how confusing the process of parenting and growing up can be. This is also an invitation for you, the readers, to talk about your own family relationships and what differences and struggles you have. My main intention with the story is to encourage self-awareness and awareness of our environment, as well as compassion for ourselves and others.")])]), _vm._v(" "), _c('p', {
    staticClass: "Acknowledgements---Bio ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I hope you enjoy ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("A Boy named Tāne")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v(" and experience it as both a fictitious story but also a story that contains many themes pertaining to personal growth and the interconnectedness of everything.")])]), _vm._v(" "), _c('p', {
    staticClass: "Acknowledgements---Bio ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I am aware that some of the vocabulary might be difficult for some readers to understand. For this reason, I have included a list of synonyms, or alternative words, for some of the language I have used. This is at the back of the book. Feel free to substitute or change any of the words to suit the readers.")])]), _vm._v(" "), _c('p', {
    staticClass: "Acknowledgements---Bio ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Aroha nui,")])]), _vm._v(" "), _c('p', {
    staticClass: "Acknowledgements---Bio ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Anna McVeigh")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer006"
    }
  }, [_c('p', {
    staticClass: "Acknowledgements"
  }, [_vm._v("Acknowledgements")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-4"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Firstly, I want to thank Tukara Matthews for creating such beautiful illustrations and for trusting me in the process of bringing this book to life. I couldn’t have done it without you!")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-4"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Secondly, I thank the production team at Austin Macauley Publishers. This book would not have come to life without you either.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-4"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Thirdly, I thank my friends and family for inspiring me by being you.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-4"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I’d also like to thank our beautiful country of Aotearoa for providing me with ongoing inspiration and a place to call home. In particular, I thank, te iwi Māori for a beautiful culture and this sacred land. May you continue to rise again.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-5"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Last, but most importantly, I want to thank Felix Tāne McVeigh for inspiring and challenging me every single day. You have provided me with many of the seeds for this story. My love for you is greater than Tāne Mahuta!")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer008"
    }
  }, [_c('p', {
    staticClass: "Graphics"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/9781398485372_txt8.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer009"
    }
  }, [_c('p', {
    staticClass: "Txt"
  }, [_vm._v("When I was born, my mother named me Tāne.")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-9"
  }, [_c('span', {
    staticClass: "CharOverride-6"
  }, [_vm._v("She named me after the great kauri tree and legendary god of the forest, Tāne Mahuta. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-9"
  }, [_c('span', {
    staticClass: "CharOverride-6"
  }, [_vm._v("In the Māori creation story, Tāne Mahuta was the eldest son of Papatūānuku (the earth mother) and Ranginui (the sky father). ")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-9"
  }, [_c('span', {
    staticClass: "CharOverride-6"
  }, [_vm._v("He and his five siblings lived in darkness within the embrace of their parents.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-9"
  }, [_c('span', {
    staticClass: "CharOverride-6"
  }, [_vm._v("Over time, Tāne Mahuta got tired of living in darkness. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-9"
  }, [_c('span', {
    staticClass: "CharOverride-6"
  }, [_vm._v("He decided to separate his parents by pushing them apart. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-9"
  }, [_c('span', {
    staticClass: "CharOverride-6"
  }, [_vm._v("By doing this, he created Te Ao Mārama (the world of light), which is the beautiful world we live in today.")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer011"
    }
  }, [_c('p', {
    staticClass: "Graphics"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/9781398485372_txt10.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer012"
    }
  }, [_c('p', {
    staticClass: "Txt"
  }, [_vm._v("My mother and I lived near Waipoua Forest, the home of Tāne Mahuta, and as a young child I liked the forest so much that I spent most of my days there.")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-9"
  }, [_c('span', {
    staticClass: "CharOverride-6"
  }, [_vm._v("Other children my age thought I was strange because I could spend hours in the forest on my own, but I never felt alone. I did feel different from other people though and sometimes that caused me to wonder if there was something wrong with me.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-9"
  }, [_c('span', {
    staticClass: "CharOverride-6"
  }, [_vm._v("My mum often reminded me, when I was home, that it was good to be different. She encouraged me to be my own best friend and not to try and be like, or liked by, everyone else.")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer014"
    }
  }, [_c('p', {
    staticClass: "Graphics"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/9781398485372_txt12.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer015"
    }
  }, [_c('p', {
    staticClass: "Txt"
  }, [_vm._v("I got confused, though, because sometimes she growled at me for just being me. She didn’t like it when I was mad, or even shy.")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-9"
  }, [_c('span', {
    staticClass: "CharOverride-6"
  }, [_vm._v("I now know that it made her feel uncomfortable.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-10"
  }, [_c('span', {
    staticClass: "CharOverride-6"
  }, [_vm._v("She was very sociable and didn’t really understand why I liked spending time on my own. She also didn’t always know how to deal with her own feelings, let alone mine. When she didn’t know what to do she would just tell me to take my shoes off and go into the forest for a walk and to connect with nature. This did help. ")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer016"
    }
  }, [_c('p', {
    staticClass: "Txt"
  }, [_vm._v("I loved being away from the confusion and the hustle and bustle of other people, the noise and pollution of traffic and the distraction of the internet.")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-9"
  }, [_c('span', {
    staticClass: "CharOverride-6"
  }, [_vm._v("Spending time in the forest gave me a sense of calm and, as I learned to quiet my mind, I began to understand the whisper of trees. Being in the forest was like meditation for me. Meditation is just a fancy word for becoming still, and connected to myself and my environment.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-9"
  }, [_c('span', {
    staticClass: "CharOverride-6"
  }, [_vm._v("My mum would try and do that by sitting still with her eyes closed but I did it in the forest. I became more present, and more embodied, in the forest.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-10"
  }, [_c('span', {
    staticClass: "CharOverride-6"
  }, [_vm._v("I also felt energetically connected to everything around me. It was magical.")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer020"
    }
  }, [_c('p', {
    staticClass: "Graphics _idGenParaOverride-1"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/9781398485372_txt15.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Txt"
  }, [_vm._v("Over time I began to feel deeply rooted to the earth and in harmony with the flora and fauna around me. I would listen to the birds, day in and day out, singing their joyous tunes to one another. I came to understand how the inhabitants of the forest communicate and live off and with each other, in harmony and bliss.")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-9"
  }, [_c('span', {
    staticClass: "CharOverride-6"
  }, [_vm._v("The more time I spent in the forest, and as I grew older, the more I felt an affinity with the trees.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-11"
  }, [_c('span', {
    staticClass: "CharOverride-6"
  }, [_vm._v("I had always liked the idea of becoming a tree; feeling solid and grounded, standing tall and on my own yet connected and at peace. I liked the idea so much that over time I started to live alongside the trees.")])]), _vm._v(" "), _c('p', {
    staticClass: "Graphics _idGenParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-6"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/9781398485372_txt17.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Graphics"
  }, [_c('span', {
    staticClass: "CharOverride-6"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/9781398485372_txt18.jpg"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer021"
    }
  }, [_c('p', {
    staticClass: "Txt"
  }, [_vm._v("Being in this environment had shown me what it means to belong. I learned that true belonging is not really about fitting in with everyone else but about being authentic. It’s about listening to my body, my mind and my soul and taking care of them.")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-9"
  }, [_c('span', {
    staticClass: "CharOverride-6"
  }, [_vm._v("Belonging comes from feeling connected and following my own path, and my own dreams.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-10"
  }, [_c('span', {
    staticClass: "CharOverride-6"
  }, [_vm._v("As a youngster I always wanted to feel accepted just as I am. Nothing in the forest judged me or tried to change me. I felt free.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-9"
  }, [_c('span', {
    staticClass: "CharOverride-6"
  }, [_vm._v("As I spent more and more time in the forest something strange started happening to me.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-10"
  }, [_c('span', {
    staticClass: "CharOverride-6"
  }, [_vm._v("I was changing. I was no longer just a young man. Slowly, yet surely, I was transforming into a tree.")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer023"
    }
  }, [_c('p', {
    staticClass: "Graphics"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/9781398485372_txt20.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer024"
    }
  }, [_c('p', {
    staticClass: "Txt"
  }, [_vm._v("I felt so calm and so happy in the life I was creating for myself. I no longer worried about anything, past or future. I never had to be anywhere, at a certain time, and I was always fed, watered and nurtured by the environment around me. Life couldn’t be better, except for one thing. Other humans occasionally entered the forest. The only thing that gave me fear, was the sound of other humans.")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-12"
  }, [_c('span', {
    staticClass: "CharOverride-6"
  }, [_vm._v("You see, I was half man and half tree now, so I felt the fear of humans but also the serenity of trees. This meant I felt fiercely protective of the forest and also my own being.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-10"
  }, [_c('span', {
    staticClass: "CharOverride-6"
  }, [_vm._v("When humans approached, I could hear the other trees whispering, “a human’s coming, a human’s coming, a human’s coming…”")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer025"
    }
  }, [_c('p', {
    staticClass: "Txt"
  }, [_vm._v("Sometimes the humans would just take photos, and sometimes they would touch the trees and stand on their roots. Sometimes they would pick the fruit or break a branch even. I would sob when this happened and my sappy tears would leak out of the bark forming on my skin.")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-9"
  }, [_c('span', {
    staticClass: "CharOverride-6"
  }, [_vm._v("My body was becoming increasingly more like a tree, you see. The more time I stood in harmony with the forest, the firmer and more bark-like my skin was becoming. The sun dried the bark forming on my skin and a combination of sun, rain and good vibrations encouraged little green shoots to pop out of my woody trunk.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-9"
  }, [_c('span', {
    staticClass: "CharOverride-6"
  }, [_vm._v("My legs became more and more firmly planted to the ground and roots started to trail down into the earth, giving me a solidity and strength that was unwavering. I was becoming planted in the earth and increasingly more tranquil as time went on.")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer027"
    }
  }, [_c('p', {
    staticClass: "Graphics"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/9781398485372_txt23.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer028"
    }
  }, [_c('p', {
    staticClass: "Txt"
  }, [_vm._v("I would stand in the forest with my arms branched out and my face to the sun, the wind and the rain.")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-10"
  }, [_c('span', {
    staticClass: "CharOverride-6"
  }, [_vm._v("I listened to the murmur of the trees and the twitter of Manu (birds), and my ears perked up whenever I heard a Tui (native bird of the forest).")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-13"
  }, [_c('span', {
    staticClass: "CharOverride-6"
  }, [_vm._v("I was especially happy when the Tui fluttered into my personal space and nestled into my branches… tweet tweet tweet. Sometimes a Tui would drop Kaikomako berries (wineberries) at my feet. I knew this meant that autumn had arrived which was a sacred time of letting go and preparing for a restful and rejuvenating winter.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-13"
  }, [_c('span', {
    staticClass: "CharOverride-6"
  }, [_vm._v("On rare occasions, a Patupaiarehe (forest fairy) would pay me a visit, silently resting on my crown. These were my favourite moments as the Patupaiarehe would always whisper gems of wisdom into my increasingly more open and honest ears. “We are eternal beings,” she might softly say, before delicately retreating into the Ngāhere, the vast and beautiful forest.")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer030"
    }
  }, [_c('p', {
    staticClass: "Graphics"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/9781398485372_txt25.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer033"
    }
  }, [_c('p', {
    staticClass: "Graphics _idGenParaOverride-1"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/9781398485372_txt26.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Txt"
  }, [_vm._v("On warm days, when no humans graced my presence, my arms would rise higher and I would feel at one with the sun in the sky and the forest around me. But when humans came, I would become smaller and lower my branches, so as not to stand out and to manage the trepidation shivering through my limbs. The human in me understood that humans can’t always be trusted, even when they mean well.")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-14"
  }, [_c('span', {
    staticClass: "CharOverride-6"
  }, [_vm._v("The times when I felt most afraid was when my life was threatened. Other trees would warn me and each other when danger was imminent but the other trees didn’t mind as much as I seemed to. They knew that if they were to die, they would grow again into younger and more beautiful trees and that life would carry on. But I still had man in me and the man in me didn’t want to die, fearing that I would wither away into the earth, never to be seen again. I was yet to understand that the fate of humans was not dissimilar to that of trees.")])]), _vm._v(" "), _c('p', {
    staticClass: "Graphics _idGenParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-6"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/9781398485372_txt28.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Txt"
  }, [_vm._v("So, whenever I heard the crunch of human footsteps and a different kind of whisper in the trees, I would become paralysed with fear. The trees would whisper, “man with a gun, man with a gun, man with a gun…” or “man with an axe, man with an axe, man with an axe…”")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-9"
  }, [_c('span', {
    staticClass: "CharOverride-6"
  }, [_vm._v("I knew these men meant no harm. Shooting an animal for tea, or cutting down a tree to put on the fire was a natural part of the human experience, for many. But because I had become a human tree,")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-10"
  }, [_c('span', {
    staticClass: "CharOverride-6"
  }, [_vm._v("I knew differently. Having the mind of a man and the heart of a tree, I didn’t want to die and I didn’t want to see other trees or animals suffer either.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-9"
  }, [_c('span', {
    staticClass: "CharOverride-6"
  }, [_vm._v("For me, they were all my brothers and sisters.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-10"
  }, [_c('span', {
    staticClass: "CharOverride-6"
  }, [_vm._v("My family. My ancestors. My heartbeat..")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer034"
    }
  }, [_c('p', {
    staticClass: "Txt"
  }, [_vm._v("Seeing an animal killed or a tree cut down made me weep and in time golden sap covered my entire body protecting me from any evil as I continued my journey from man to tree. ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-9"
  }, [_c('span', {
    staticClass: "CharOverride-6"
  }, [_vm._v("Finally, one day, I was no longer a man but a beautiful golden Kauri tree standing in the forest.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-10"
  }, [_c('span', {
    staticClass: "CharOverride-6"
  }, [_vm._v("My roots were shallow but my trunk was strong and I felt invincible, protected and deeply peaceful.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-9"
  }, [_c('span', {
    staticClass: "CharOverride-6"
  }, [_vm._v("And as I grew stronger and larger and more powerful, just like my ancestor, Tāne Mahuta, I came to realise there was no death – only Life.")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer036"
    }
  }, [_c('p', {
    staticClass: "Graphics"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/9781398485372_txt31.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer037"
    }
  }, [_c('p', {
    staticClass: "Author-Heading ParaOverride-6"
  }, [_vm._v("Glossary")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-5"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Flora")]), _c('span', {
    staticClass: "CharOverride-6"
  }, [_vm._v(" – plants")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-5"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Fauna")]), _c('span', {
    staticClass: "CharOverride-6"
  }, [_vm._v(" – animals")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-5"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Inhabitants")]), _c('span', {
    staticClass: "CharOverride-6"
  }, [_vm._v(" – members")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-5"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Affinity")]), _c('span', {
    staticClass: "CharOverride-6"
  }, [_vm._v(" – connection / understanding and liking")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-5"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Authentic")]), _c('span', {
    staticClass: "CharOverride-6"
  }, [_vm._v(" – genuine / true / real")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-5"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Murmur")]), _c('span', {
    staticClass: "CharOverride-6"
  }, [_vm._v(" – sound / whisper")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-5"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Rejuvenating")]), _c('span', {
    staticClass: "CharOverride-6"
  }, [_vm._v(" – healing / restorative / revitalising")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-5"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Nurtured")]), _c('span', {
    staticClass: "CharOverride-6"
  }, [_vm._v(" – looked after / cared for / protected / helped")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-5"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Good vibrations")]), _c('span', {
    staticClass: "CharOverride-6"
  }, [_vm._v(" – positive energy")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-5"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Unwavering")]), _c('span', {
    staticClass: "CharOverride-6"
  }, [_vm._v(" – constant / steady / fixed / resolute")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-5"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Trepidation")]), _c('span', {
    staticClass: "CharOverride-6"
  }, [_vm._v(" – fear / anxiety / nervousness / agitation")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-5"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Invincible")]), _c('span', {
    staticClass: "CharOverride-6"
  }, [_vm._v(" – powerful / indestructible / invulnerable")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d9115daa","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781398485389_Epub.vue
// module id = 57
// module chunks = 0